import { useEffect, useState } from "react";
// Browsers share one animation clock between all <img> elements with the same
// URL, so showing a GIF again would continue mid-loop. Each restart gets its
// own blob URL, which the browser treats as a new image starting at frame 0.
const blobs = new Map<string, Promise<Blob>>();
export function StageImage({
  src,
  alt,
  restart,
}: {
  src: string;
  alt: string;
  restart: number;
}) {
  const [url, setUrl] = useState(src);
  useEffect(() => {
    if (!restart) {
      setUrl(src);
      return;
    }
    let alive = true,
      made = "";
    if (!blobs.has(src))
      blobs.set(
        src,
        fetch(src, { credentials: "same-origin" }).then((r) => {
          if (!r.ok) throw new Error(String(r.status));
          return r.blob();
        }),
      );
    blobs
      .get(src)!
      .then((blob) => {
        if (!alive) return;
        made = URL.createObjectURL(blob);
        setUrl(made);
      })
      .catch(() => {
        blobs.delete(src);
        if (alive) setUrl(src);
      });
    return () => {
      alive = false;
      if (made) URL.revokeObjectURL(made);
    };
  }, [src, restart]);
  return <img src={url} alt={alt} draggable={false} />;
}
